import { css } from '@emotion/react';
import { CertificationType, CertificationUserTestQuestionType } from '@types';
import { Loader } from '@components/utils';

import CertificationTable from './CertificationTable';
import Header from './Header';

export type CertificationPropsType = {
  certification?: CertificationType
  questionsRespondentFiltered: CertificationUserTestQuestionType[]
  isLoading?: boolean
};
const Certification = ({
  certification,
  questionsRespondentFiltered,
  isLoading,
}: CertificationPropsType) => {
  return (
    <div>
      <Header certification={certification} />
      <div
        css={css`
          margin-top: 16px;
        `}
      >
        {isLoading && <Loader />}
        {!isLoading && (
          <CertificationTable questionsRespondentFiltered={questionsRespondentFiltered} />
        )}
      </div>
    </div>
  );
};

export default Certification;
